module.exports = __webpack_public_path__ + "img/activity_btn.ff540c63.png";